import { loadModel } from './components/load/load.js';
import { createCamera } from './components/camera.js';
import { createLights } from './components/lights.js';
import { createScene } from './components/scene.js';

// import { createControls } from './systems/controls.js';
import { createRenderer } from './systems/renderer.js';
import { Resizer } from './systems/Resizer.js';
import { Loop } from './systems/Loop.js';

import { Color, Mesh, PlaneGeometry, CircleGeometry, CameraHelper, ShaderMaterial, MultiplyBlending, CanvasTexture, MeshBasicMaterial, MeshPhysicalMaterial, MeshStandardMaterial, MeshGradientMaterial, MeshPhongMaterial, DoubleSide, MeshLambertMaterial } from 'three';
// import { TransformControls } from 'three/examples/jsm/controls/TransformControls.js';
import { Reflector } from './objects/Reflector.js';
// import { MeshReflectorMaterial } from './systems/MeshReflectorMaterial.js'

import { DragControls } from 'three/examples/jsm/controls/DragControls.js';
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
import { SSRPass } from 'three/examples/jsm/postprocessing/SSRPass.js';
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js';
import { GammaCorrectionShader } from 'three/examples/jsm/shaders/GammaCorrectionShader.js';
import { ReflectorForSSRPass } from 'three/examples/jsm/objects/ReflectorForSSRPass.js';

import { SSREffect } from "screen-space-reflections"
import * as POSTPROCESSING from "postprocessing"

// import Hammer from 'hammerjs';

let camera;
let controls;
let renderer;
let scene;
let loop;
let transformControl;
let composer;

class World {
  constructor(container) {
    camera = createCamera();
    renderer = createRenderer();
    scene = createScene();
    loop = new Loop(camera, scene, renderer);
    container.append(renderer.domElement);
    renderer.domElement.style.transform = 'translate3d(0, 3vh, 0)';

    const { ambientLight, mainLight, pointLight_1, pointLight_2, pointLight_3 } = createLights();
    scene.add(ambientLight, mainLight, pointLight_1, pointLight_2, pointLight_3);

    // const h = new CameraHelper(mainLight.shadow.camera)
    // scene.add(h)

    const resizer = new Resizer(container, camera, renderer);

    // this.cx = 0;
    // this.cx_temp = 0;
    // this.targetRotation = 0;

    this.params = {
			enableSSR: true,
			autoRotate: true,
			otherMeshes: true,
			groundReflector: true,
		};
    this.composer = null;
  }

  async init(options) {
    const hero = await loadModel(renderer.domElement, options);
    scene.add(hero);

    loop.updatables.push(hero)

    // controls.target.copy(hero.position);

    //镜面
    const geometry = new PlaneGeometry(10, 1.25);
    // const geometry = new CircleGeometry(4,32);
    const mirror = new Reflector( geometry, {
      clipBias: 0,
      textureWidth: renderer.domElement.width * 0.4,
      textureHeight: renderer.domElement.width * 0.4,
      // color: 0x000000
    });
    mirror.rotation.x = -0.5 * Math.PI;
    mirror.position.y = -1;
    scene.add(mirror);


    //顶棚（用于镜面反射）
    const geometry2 = new PlaneGeometry(renderer.domElement.width * 0.01, renderer.domElement.height * 0.01);
    const material = new MeshBasicMaterial({ color: 0xe8e7e7, side: DoubleSide });
    const plane = new Mesh(geometry2, material);
    plane.position.z = -10;
    scene.add( plane );

    // const plane = new Mesh(
    //   new CircleGeometry(0.8,32),
    //   new MeshPhongMaterial( { color: 0x999999, specular: 0x101010 } )
    // );
    // plane.rotation.x = -0.5 * Math.PI;
    // plane.position.y = -0.92;
    // // plane.receiveShadow = true;
    // scene.add( plane );

    // 镜面
    // const geometry = new CircleGeometry(0.8,32);
    // const groundReflector = new ReflectorForSSRPass( geometry, {
    //   clipBias: 0,
    //   // textureWidth: window.innerWidth,
    //   // textureHeight: window.innerHeight,
    //   color: 0xD2D2D2,
    //   useDepthTexture: false,
    // } );
    // groundReflector.rotation.x = -0.5 * Math.PI;

    // composer = new EffectComposer( renderer );
    // const ssrPass = new SSRPass( {
    //   renderer,
    //   scene,
    //   camera,
    //   // width: innerWidth,
    //   // height: innerHeight,
    //   groundReflector: groundReflector,
    //   selects: [ plane ]
    // } );


    // composer.addPass( ssrPass );
    // composer.addPass( new ShaderPass( GammaCorrectionShader ) );
    // const composerUpdate = {
    //   tick: () => composer.render()
    // };
    // loop.updatables.push(composerUpdate)


    // composer = new POSTPROCESSING.EffectComposer(renderer)
    // const ssrEffect = new SSREffect(scene, camera)
    // const ssrPass = new POSTPROCESSING.EffectPass(camera, ssrEffect)
    // composer.addPass(ssrPass)

    // composer.tick = () => composer.render();
    // loop.updatables.push(composer)


    // 模型旋转
    // let mc = new Hammer.Manager(renderer.domElement);
    // let Pan = new Hammer.Pan({ direction: Hammer.DIRECTION_HORIZONTAL });
    // mc.add(Pan);
    // mc.on('panstart', (e) => {
    //   // 初始化位置
    //   this.cx = e.center.x;
    //   this.cx_temp = this.cx;
    // });
    // mc.on('pan', (e) => {
    //   this.cx = e.center.x;
    //   let move = this.cx - this.cx_temp;
    //   this.targetRotation = this.targetRotation + move * 0.005;
    //   this.cx_temp = this.cx;
    // });

    // hero.tick = () => {
    //   hero.rotation.y += (this.targetRotation - hero.rotation.y) * 0.06;
    // }
  }

  render() {
    // if(this.params.enableSSR) {
      // composer.render();
    // }else {
    //   renderer.render(scene, camera);
    // }
  }

  start() {
    loop.start(composer);
  }

  stop() {
    loop.stop();
  }
}

export { World };
